import { Tooltip } from '@kira/checkpoint-shared-frontend';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

interface SidebarNavigationItemProps {
  description: string;
  to: string;
  icon?: JSX.Element;
  activeIcon?: JSX.Element;
  isCollapsed?: boolean;
  isShowing?: boolean;
  wrapperClassNames?: string;
  dataTestId?: string;
}

const SidebarNavigationLink = ({
  description,
  to,
  icon,
  activeIcon,
  isCollapsed,
  isShowing = true,
  wrapperClassNames,
  dataTestId,
}: SidebarNavigationItemProps) => {
  const [isActive, setIsActive] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsActive(false);
    const toLocation = pathname.split('/');
    const lastLocation = toLocation[toLocation.length - 1];
    const competencyRoute = `${
      toLocation[toLocation.length - 2]
    }/${lastLocation}`;

    if (lastLocation === to) setIsActive(true);
    if (competencyRoute === to) setIsActive(true);
  }, [pathname]);

  const isActiveClasses = twMerge(
    'bg-kira-blue-800',
    'bg-opacity-10',
    '!border-kira-blue-800'
  );

  const wrapperClasses = twMerge(
    'border-l-4',
    'border-transparent',
    'flex-grow',
    'flex',
    'hover:bg-kira-blue-800',
    'hover:bg-opacity-10',
    'items-center',
    'px-4',
    'prose-button-lg',
    'rounded-r-lg',
    'w-full',
    isActive && isActiveClasses,
    'p-3',
    wrapperClassNames || ''
  );

  const handleOnClick = () => {
    navigate(to);
  };

  return isShowing ? (
    <div className="mr-4 flex cursor-pointer items-center text-kira-slate-700 2xl:mr-0">
      <Tooltip
        textContent={description}
        isEnabled={isCollapsed}
        tooltipClassNames="left-16 !-mt-12 z-10"
      >
        <button
          type="button"
          data-testid={dataTestId}
          className={wrapperClasses}
          onClick={handleOnClick}
        >
          {icon && (
            <div className="h-6 w-6">
              {isActive && activeIcon ? activeIcon : icon}
            </div>
          )}
          {!isCollapsed ? (
            <div className="overflow-clip truncate px-2">{description}</div>
          ) : null}
        </button>
      </Tooltip>
    </div>
  ) : null;
};

export default SidebarNavigationLink;
